import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Tenant} from '../models/tenant.model';

@Injectable()
export class TenantService {

  private tenantId:string;

  private subject = new BehaviorSubject<string>(undefined);

  tenantId$:Observable<string> = this.subject.pipe(filter(tenantId => !!tenantId));

  tenant: Tenant;

  get id() {
    return this.tenantId;
  }

  set id(tenantId:string) {
    console.log(`Setting the tenantId ${tenantId} in the tenant service.`);
    this.tenantId = tenantId;
    this.subject.next(tenantId);
  }

  path(firesStorePath) {
    return `schools/${this.id}/${firesStorePath}`;
  }

}
